export default {"src":"/_next/static/media/icon-flag-japan.62aca654.svg","height":27,"width":40,"blurWidth":0,"blurHeight":0};